export interface EventBus {
  publish: () => void;
  subscribe: (callback: () => void) => () => void;
}

export function createEventBus(name: string): EventBus {
  const BusEventTarget = new EventTarget();

  return {
    publish: () => {
      BusEventTarget.dispatchEvent(new Event(name));
    },
    subscribe: (callback) => {
      BusEventTarget.addEventListener(name, callback);

      return () => {
        BusEventTarget.removeEventListener(name, callback);
      };
    },
  };
}
